import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Box } from "@mui/material";
import Header from "../pages/Header";
import moviesStore from "../stores/moviesStore";
import MainBody from "./MainBody";
import Pagination from "./Pagination";
import MainBodyPremier from "./MainBodyPremier";
import MainBodyFilterPremier from "./MainBodyFilterPremier";
import PortalNavigation from "./PortalNavigation";

const AppWrapperPremier: React.FC = observer(() => {
  const [filterString, setFilterString] = useState("");

  useEffect(() => {
    // первый запрос на страницу 1
    moviesStore.fetchMoviesPremier(1);
  }, []);

  const handleApplyFilters = (str: string) => {
    setFilterString(str);
    moviesStore.fetchMoviesPremier(1, undefined, str); // передаем строку фильтров
  };

  return (
    <Box height="100vh" display="flex" flexDirection="column">
      {/* Верхний Header */}
      <Header />

      {/* Контент */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        p={2}
      >
        <PortalNavigation />

        {/* компонент фильтра премьер */}
        <MainBodyFilterPremier
          onApplyFilters={(str) => {
            setFilterString(str); // сохраняем строку фильтров
            moviesStore.fetchMoviesPremier(1, undefined, str); // передаем строку в store
          }}
        />

        {/* Список фильмов */}
        <MainBodyPremier />

        {/* Пагинация */}
        <Pagination
          currentPage={moviesStore.currentPage}
          totalPages={moviesStore.totalPages}
          onChange={(page) =>
            moviesStore.fetchMoviesPremier(page, undefined, filterString)
          }
        />
      </Box>
    </Box>
  );
});

export default AppWrapperPremier;
